export default function deleteDomainReducer
    (state = { error:null, success:null, processing:false }, action) {

    switch (action.type)
    {
        case 'DELETE_DOMAIN_SUCCESS':
            return {...state, ...{success: action.success }};

        case 'DELETE_DOMAIN_ERROR':
            return {...state, ...{ error: action.error }};

        case 'DELETE_DOMAIN_PROCESSING':
            return {...state, ...{ processing: action.processing }};

        default: return state;
    }
}